import { render, staticRenderFns } from "./Shutter.vue?vue&type=template&id=3530fdac&"
import script from "./Shutter.vue?vue&type=script&lang=js&"
export * from "./Shutter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports